import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaLeaf, FaTrashAlt, FaExclamationTriangle, FaRecycle } from 'react-icons/fa';
import './Impact.css';

const Impact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const impactCards = [
    {
      icon: <FaLeaf />,
      title: 'GHG reduction',
      description: 'Self-powered and GHG-free process, enabling over 3 tons of CO₂eq reduction per ton of plastic waste'
    },
    {
      icon: <FaTrashAlt />,
      title: 'Diverts waste from landfill',
      description: 'Diverts the currently unrecycled plastic waste back into the circular economy though the production of circular-carbon commodities'
    },
    {
      icon: <FaExclamationTriangle />,
      title: 'Solving the plastic crisis',
      description: 'Overcoming the current plastic waste recycling technologies barriers leapfrogging recycling rates far beyond the current 9%'
    },
    {
      icon: <FaRecycle />,
      title: 'Closing the plastic loop',
      description: 'True circular economy solution, closing the plastic loop by converting plastic waste into commodity feedstock for plastic production'
    }
  ];

  return (
    <section id="impact" className="impact" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Impact</h2>
          <p className="section-subtitle">Latent Energy Proprietary Technology offers a holistic solution to the plastic waste crisis</p>
        </motion.div>

        <div className="impact-grid">
          {impactCards.map((card, index) => (
            <motion.div
              key={index}
              className="impact-card"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
            >
              <div className="impact-icon">{card.icon}</div>
              <h3 className="impact-title">{card.title}</h3>
              <p className="impact-description">{card.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;
